import React from 'react';
import {WidgetProps} from '../types';

const CompatibleDateWidget: React.FC<WidgetProps> = ({}) => {
    return null;
};

export default CompatibleDateWidget;
